import { RouteRecordNameGeneric } from 'vue-router'

/*
|--------------------------------------------------------------------------
| Manager-only screens (web-30 Q4, extended by E2E-R4-01)
|--------------------------------------------------------------------------
|
| Every org screen is manager-only for the 15 Oct release. web-30 Q4 kept
| staff off the manager screens (settings, onboarding, create forms,
| checkout); E2E-R4-01 (12 Oct) adds the rest: the dashboard, notifications,
| schedule, people, time off and broadcasts all read lists the API refuses
| staff, so staff only ever saw "This action is unauthorized.". The router
| sends staff to My Account instead, which points them to the CliniShift app.
|
| Decided instead of per-route permission metas: can() never matches the
| API's dotted permission names (WEB-03/UNIT-20), so the router checks the
| site's capability flag (site.permissions.shifts.can_manage).
*/
const MANAGER_ONLY_PREFIXES = ['/(app)/[org]']

export function isManagerOnlyRoute(name: RouteRecordNameGeneric | null | undefined): boolean {
  if (typeof name !== 'string') return false

  return MANAGER_ONLY_PREFIXES.some((prefix) => name.startsWith(prefix))
}

/**
 * Staff have no org screens this release (E2E-R4-01). Only a site from GET api/orgs/{id} will do:
 * the org list (GET api/orgs) reports every permission as false, managers included.
 */
export function canUseOrgScreens(site: { permissions: { shifts: { canManage: boolean } } }): boolean {
  return site.permissions.shifts.canManage
}
